import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

interface QuickStart {
  roleName: string;
  scenarioName?: string | null;
  onClick: () => void;
}

interface WelcomeStateProps {
  onStart: () => void;
  quickStart?: QuickStart;
}

/** Center content shown in the main layout when no project is selected (new flow). */
export function WelcomeState({ onStart, quickStart }: WelcomeStateProps) {
  return (
    <div className="flex items-center justify-center h-full overflow-y-auto p-6">
      <div className="w-full max-w-xl space-y-8 py-8 text-center">
        <div className="space-y-3">
          <div className="w-12 h-12 rounded-xl bg-muted flex items-center justify-center mx-auto">
            <Sparkles className="w-6 h-6 text-foreground" />
          </div>
          <h1 className="text-3xl font-semibold tracking-tight">Ready to start?</h1>
          <p className="text-base text-muted-foreground max-w-md mx-auto leading-relaxed">
            Upload a recording and get AI-powered analysis tailored to your role.
          </p>
        </div>

        <div className="flex flex-col items-center gap-3">
          <Button size="lg" className="gap-2" onClick={onStart}>
            Start New Project
            <ArrowRight className="w-4 h-4" />
          </Button>

          {quickStart ? (
            <button
              type="button"
              onClick={quickStart.onClick}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Quick start:{" "}
              <span className="font-medium text-foreground">{quickStart.roleName}</span>
              {quickStart.scenarioName ? ` · ${quickStart.scenarioName}` : ""}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default WelcomeState;
